import { render, staticRenderFns } from "./ClientStockRateView.vue?vue&type=template&id=ce3eb0f2"
import script from "./ClientStockRateView.vue?vue&type=script&lang=js"
export * from "./ClientStockRateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports